import findIndex from 'lodash/findIndex'
import { ContentPushActions } from '../actions/contentPush'

// Default start date
const defaultGoLiveDateDate = new Date()
defaultGoLiveDateDate.setUTCDate(new Date().getUTCDate() + 7)
defaultGoLiveDateDate.setUTCHours(6)
defaultGoLiveDateDate.setUTCMinutes(0)
defaultGoLiveDateDate.setUTCSeconds(0)
export const defaultGoLiveDate = defaultGoLiveDateDate.getTime()

// Default end date
const defaultExpiryDateDate = new Date()
defaultExpiryDateDate.setUTCDate(new Date().getUTCDate() + 9)
defaultExpiryDateDate.setUTCHours(6)
defaultExpiryDateDate.setUTCMinutes(0)
defaultExpiryDateDate.setUTCSeconds(0)
export const defaultExpiryDate = defaultExpiryDateDate.getTime()

const initialForm = {
    countries: [],
    date_end: null,
    date_start: defaultGoLiveDate,
    group: '3',
    isMediaReady: false,
    level_required: '1',
    media: [],
    name: '',
    notes: null,
    purchase_order: null,
    status: '1',
}

const initialState = {
    error: null,
    list: [],
    isUploading: false,
    isWorking: false,
    itemsPerPage: 0,
    page: 0,
    selected: { ...initialForm },
    total: 0,
    contentPushStatus: [],
    contentPushGroups: [],
    contentPushRequiredLevels: [],
}

function isSelected(item, array) {
    const index = array.findIndex((itemInArray) => itemInArray.id === item.id && itemInArray.selected)
    return index
}

export default (state = initialState, { type, payload = {} }) => {
    switch (type) {
        case 'API_CALL##FAILURE':
            return {
                ...state,
                error: payload.message,
                isUploading: false,
                isWorking: false,
                selected: { ...initialForm },
            }
        case 'CONTENT_PUSH##REQUEST':
            return {
                ...state,
                error: null,
                isWorking: true,
            }
        case 'CONTENT_PUSH##SUCCESS':
            return {
                ...state,
                isWorking: false,
                itemsPerPage: payload.per_page,
                list: payload.data.map((cp) => ({
                    ...cp,
                    date_end: cp.date_end && new Date(cp.date_end).getTime(),
                    date_start: cp.date_start && new Date(cp.date_start).getTime(),
                })),
                page: payload.current_page,
                total: payload.total,
            }
        case 'CONTENT_PUSH_CREATE##SUCCESS':
            return {
                ...state,
                isWorking: false,
                list: [
                    ...state.list,
                    {
                        ...payload,
                        date_end: new Date(`${payload.date_end} UTC`).getTime(),
                        date_start: new Date(`${payload.date_start} UTC`).getTime(),
                    },
                ],
            }
        case 'CONTENT_PUSH_EDIT##SUCCESS':
            const index = findIndex(state.list, ({ id }) => id === payload.id)
            return {
                ...state,
                isWorking: false,
                list: [
                    ...state.list.slice(0, index),
                    {
                        ...payload,
                        date_end: new Date(payload.date_end).getTime(),
                        date_start: new Date(payload.date_start).getTime(),
                    },
                    ...state.list.slice(index + 1, state.list.length),
                ],
            }
        case 'CONTENT_PUSH_FORM_EDIT': {
            const selected = state.selected ? { ...state.selected } : {}

            return {
                ...state,
                selected: {
                    ...selected,
                    [payload.name]: payload.value,
                },
            }
        }
        case 'CONTENT_PUSH_FORM_CLEAR': {
            return {
                ...state,
                selected: {
                    ...initialForm,
                },
            }
        }
        case 'CONTENT_PUSH_SHOW##SUCCESS':
            return {
                ...state,
                selected: {
                    ...payload,
                    countries: payload.countries.map(({ code }) => code),
                    date_end: payload.date_end && new Date(payload.date_end).getTime(),
                    date_start: payload.date_start && new Date(payload.date_start).getTime(),
                },
            }
        case 'CP_MEDIA_CREATE##REQUEST':
            return {
                ...state,
                error: null,
                isUploading: true,
            }
        case 'CP_MEDIA_CREATE##SUCCESS':
            return {
                ...state,
                isUploading: false,
                selected: {
                    ...state.selected,
                    isMediaReady: true,
                },
            }
        case ContentPushActions.FETCH_CONTENT_PUSHES_STATUS_SUCCESS:
            const { contentPushStatus } = state
            const statusList = payload.map((status) => {
                const { id } = status
                let selected = false
                if (isSelected(status, contentPushStatus) >= 0) selected = true
                return {
                    ...status,
                    value: id,
                    selected,
                }
            })
            return {
                ...state,
                contentPushStatus: statusList,
            }

        case ContentPushActions.FETCH_CONTENT_PUSHES_GROUP_SUCCESS:
            const { contentPushGroups } = state
            const groups = payload.map((group) => {
                const { id } = group
                let selected = false
                if (isSelected(group, contentPushGroups) >= 0) selected = true
                return {
                    ...group,
                    value: id,
                    selected,
                }
            })
            return {
                ...state,
                contentPushGroups: groups,
            }
        case ContentPushActions.FETCH_CONTENT_PUSHES_LEVEL_REQUIRED_SUCCESS:
            const { contentPushRequiredLevels } = state
            const levelsRequired = payload.map((level) => {
                const { id } = level
                let selected = false
                if (isSelected(level, contentPushRequiredLevels) >= 0) selected = true
                return {
                    ...level,
                    value: id,
                    selected,
                }
            })
            return {
                ...state,
                contentPushRequiredLevels: levelsRequired,
            }
        case ContentPushActions.CHANGE_CONTENT_PUSH_FILTERS: {
            return {
                ...state,
                contentPushRequiredLevels: payload.levels,
                contentPushGroups: payload.groups,
                contentPushStatus: payload.status,
            }
        }
        default:
            return state
    }
}
